<div [cssInjectionScope]="cssInjectionScopeId">
    <div #htmlContainer [class]="htmlContainerClass"></div>
</div>